import { uiRows } from './types-def.js';
/** `web/history` (1.V-2): a document's revisions. */
export const HISTORY_INTERACTIONS = uiRows([
    {
        id: 'history.restore.revision',
        module: 'web/history',
        behavior: 'Restoring a revision restores its page text as a new revision; the text it replaced stays in the history',
        owner: '1.V-2',
        since: 'exit-1a',
    },
]);
//# sourceMappingURL=history.js.map